export default __webpack_public_path__ + "static/fall2-d952402ae55568b9aa037a4dd744bdeb.webp";